// extracted by mini-css-extract-plugin
export default {"NavButton":"ProfileButtons_NavButton__PnjI0","NavButtonActive":"ProfileButtons_NavButtonActive__ihf54"};